import { useParams } from 'react-router-dom';
import { useUnit } from './use-unit';

export const useCurrentUnit = () => {
  const { unitId } = useParams<{ unitId: string }>();
  const currentUnitId = parseInt(unitId ?? '-1');

  return useUnit(currentUnitId);
};
